'use client';
import { Button, Grid, Stack, Typography } from '@mui/material';
import { useRouter } from 'next/navigation';
import { Doodles } from '../../assets';

/**
 * ErrorPage component renders a custom 404 error page.
 *
 * It includes a doodle illustration and error message
 *
 * @returns {React.JSX.Element} The rendered ErrorPage component.
 */

export const ErrorPage = () => {
  const router = useRouter();

  return (
    <Grid
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        textAlign: 'center',
        gap: 4,
        width: '100%',
        paddingBottom: { xs: 4, md: 0 },
      }}
      data-testid="error-page"
    >
      <Stack alignItems="center" gap={4}>
        <Doodles type="end" />
        <Stack gap={2}>
          <Typography variant="h1">Ups! Ha habido un error</Typography>
        </Stack>
      </Stack>
      <Button variant="contained" onClick={() => router.refresh()}>
        Reintentar
      </Button>
    </Grid>
  );
};
